import React from 'react';
import classnames from 'classnames';

import "./tag-list.scss";
import { ManningOnlineStore } from '../../store/ManningOnlineStore';
import { ITag } from '../../models/ITag';

export interface IProps {
    store: ManningOnlineStore;
    roundIcons?: boolean;
    replacementIcon?: string;
}
export interface IState {
    isShowingAll: boolean;
}

export class TagList extends React.Component <IProps, IState> {
    private hasBeenMounted: boolean;
    
    constructor(props: IProps) {
        super(props);

        this.handleToggleMoreClick = this.handleToggleMoreClick.bind(this);
        this.onStoreChange = this.onStoreChange.bind(this);

        this.state = {
            isShowingAll: false
        };
    }

    private onStoreChange(){
        this.hasBeenMounted && this.forceUpdate();
    }

    public componentDidMount(){
        this.hasBeenMounted = true;
        this.props.store.onTagsChange(this.onStoreChange);
    }

    public componentWillUnmount(){
        this.hasBeenMounted = false;

        this.props.store.offTagsChange(this.onStoreChange);
    }

    public render(){
        const tags = this.props.store.getAllTags()
        if(tags == null || tags.length == 0) {
            return null; 
        }

        const displayedTags = this.getDisplayedRecommendedItems(tags);
        
        return <div className={classnames("tag-list-root", {"rounded-icons": this.props.roundIcons, "is-showing-all": this.state.isShowingAll})}>
                    <div>
                        {displayedTags.map(item => this.renderTags(item))}
                    </div>
                    <div className="_footer">
                        {
                            displayedTags.length != tags.length 
                            && <button onClick={this.handleToggleMoreClick}>show more</button>
                        }
                    </div>
               </div>
    }

    private getDisplayedRecommendedItems(tags: ITag[]): ITag[] {
        if(this.state.isShowingAll) { return tags; }
        return tags.slice(0, 4);
    }

    private renderTags(tag: ITag){
        return <div className="_tag" key={tag.id + tag.name}>
                    <div className="_icon-description-column">
                        { !tag.imageUrl && <div className="_item-replacement-icon"><i className={classnames("fa", this.props.replacementIcon)}/></div>}
                        { tag.imageUrl && <img src={tag.imageUrl} width="32" height="32"/>}
                        <div>
                            <div>
                                <span className="_item-title" dangerouslySetInnerHTML={{__html: tag.name}}></span>
                            </div>
                            <div className="_item-description" dangerouslySetInnerHTML={{__html: tag.description}}></div>
                        </div>
                    </div>
                    <div className="_item-follow-part">
                        <button className={classnames({"_followed": tag.isFollowed})} onClick={e => this.handleFollowClick(tag)}>
                            {!tag.isFollowed ? <i className="fa fa-plus"></i> : null} 
                            { tag.isFollowed ? "following" : "follow" }
                        </button>
                    </div>
               </div>
    }

    private handleToggleMoreClick(){
        this.setState({
            isShowingAll: !this.state.isShowingAll
        })
    }

    private handleFollowClick(tag: ITag){
        tag.isFollowed ? this.props.store.unfollowTag(tag)
                         : this.props.store.followTag(tag);
    }
}